import {field} from "../../generic/tables";
import i18n, {t} from "i18next";
import EditModalChildren from "./EditModalChildren";
import {ENTITIES, getPermissions} from "../../../lib/utils/hooks/useRoleSystem";
import DirectoryTemplate from "../DirectoryTemplate";
import React from "react";
import {TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER} from "sv-common/constants/typeExpensesVisibility";

const getProductOptions = (language) => ([
    ...Object.keys(TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER[language])
        .map(productType =>
            <option value={productType} key={productType}>{TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER[language][productType]}</option>
        )
])

const TypeExpenses = (props) => {
    const {language} = i18n;

    const translatedTypes = getProductOptions(language).map(({props}) => ({key: props.value, value: props.children}));

    const renderTranslatedVisibility = ({visibility}) => visibility?.map(vis => {
        const translatedType = translatedTypes.find(t => t.key === vis)?.value
        return translatedType ? translatedType + ', ' : '';
    }).join('').slice(0, -2);

    return <DirectoryTemplate
        fields={[
            field(t('directories.typeExpenses.name'), true, "name"),
            field(t('directories.typeExpenses.key'), false, "key"),
            field(t('directories.typeExpenses.visibility'), false, "visibility", renderTranslatedVisibility),
        ]}
        entityName={'type-expenses'}
        EditModalChildren={EditModalChildren}
        deletable
        editable
        permissions={getPermissions(ENTITIES.TYPE_EXPENSES)}
        {...props}
    />
}

export default TypeExpenses;